"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotographerSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const geography_1 = require("../utility/geography");
const mongo_1 = require("../utility/mongo");
exports.PhotographerSchema = joi_1.default.object({
    _id: mongo_1.ObjectIdSchema,
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    isActive: joi_1.default.boolean().required(),
    salesforceId: joi_1.default.string().required(),
    uuid: joi_1.default.string().uuid().required(),
    email: joi_1.default.string().required(),
    // FIXME: we have some photographers without googleMail
    googleMail: joi_1.default.string().allow(null),
    // FIXME: we have hundreds of photographers without a phone
    phone: joi_1.default.string().allow(null),
    // FIXME: we have hundreds of photographers without calendarID
    calendarID: joi_1.default.string().allow(null),
    name: joi_1.default.string().required(),
    // FIXME: we have some photographers without firstName
    firstName: joi_1.default.string().allow(null),
    skills: joi_1.default.array().items(joi_1.default.string()).required(),
    tags: joi_1.default.array().items(joi_1.default.string()),
    language: joi_1.default.string().allow(null),
    // FIXME: we have some photographers without these values
    wageCurrency: joi_1.default.string(),
    wagePerHour: joi_1.default.number(),
    amountOfFreeKm: joi_1.default.number().allow(null),
    costPerKm: joi_1.default.number().allow(null),
    isRisky: joi_1.default.boolean(),
    location: joi_1.default.object({
        // FIXME: we have some photographers without location.geometry
        geometry: geography_1.PointSchema,
        // FIXME: we have some photographers without precise address or sfLocation at all
        sfLocation: joi_1.default.object({
            Street: joi_1.default.string().allow(null),
            PostalCode: joi_1.default.string().allow(null),
            Country: joi_1.default.string().allow(null),
            City: joi_1.default.string().allow(null),
            CountryCode: joi_1.default.string().allow(null),
            State: joi_1.default.string().allow(null),
            StateCode: joi_1.default.string().allow(null)
        })
    }).required()
}).meta({ className: 'Photographer' });
//# sourceMappingURL=PhotographerSchema.js.map